import { UpdateMiniObserver } from 'src/components/PersistentMiniEpg/MiniObserver';
import AbstractDataModel from './../devices/all/AbstractDataModel';

/*
* Cache of live channels, para combine streams
*/
class ChannelBlockedUtil extends AbstractDataModel {
  constructor() {
    super();
  }

  set(element, value, timeToExpire) {

    //Valida que si un objeto ya ha expirado lo elimine
  

    var data_obj = {};
    var data_obj_aux = this.get(element);
    data_obj.expiretime = this.createExpireTime(timeToExpire || data_obj_aux && data_obj_aux.expiretime || false);
    data_obj.data = value;

    if(typeof value === 'undefined') {
      delete this.__elements[element];
    }
    else {
      this.__elements[element] = data_obj;
    }

    UpdateMiniObserver.fire();

    return this;
  }
}
const channelBlockedUtil = new ChannelBlockedUtil();
export default channelBlockedUtil;


// WEBPACK FOOTER //
// ./src/utils/ChannelBlockedUtil.js